import type { SupabaseClient } from '@supabase/supabase-js'
import type { ExchangeCodeForSession } from '@/modules/auth/use-cases'

export class SupabaseExchangeCodeForSessionRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: ExchangeCodeForSession = async (code) => {
    const { error } = await this.client.auth.exchangeCodeForSession(code)
    if (error) {
      throw error
    }
  }
}
